import React from 'react';
import { CheckIcon, XIcon } from 'lucide-react';
import { Section, SectionTitle } from './Section';
import { CTAButton } from '../CTAButton';
import { afterItems, beforeItems } from '../../data/content';
export function BeforeAfter() {
  return <Section tone="white" data-id="element-67" data-mp="26mmaii144xio">
      <SectionTitle eyebrow="The transformation" data-id="element-68" data-mp="22krdhpq7t6ap">
        Before &amp; After the Blueprint
      </SectionTitle>

      <div className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-69" data-mp="2zarx7abq8wl5">
        <div className="rounded-3xl border border-navy/10 bg-navy/[0.03] p-5" data-id="element-70" data-mp="2za8pemfsjoku">
          <h3 className="text-center text-[12px] font-bold uppercase tracking-[0.16em] text-navy/50" data-id="element-71" data-mp="2ud8ik9b4ahso">
            Before
          </h3>
          <ul className="mt-4 space-y-3" data-id="element-72" data-mp="2qc6i5p5grzp4">
            {beforeItems.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] leading-snug text-navy/60" data-id="element-73" data-mp="2laz79h80yke8">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-red-100" data-id="element-74" data-mp="19vu5cffpwpvo">
                  <XIcon className="h-3 w-3 text-red-600" data-id="element-75" data-mp="176nqw527dpb8" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>

        <div className="rounded-3xl border-2 border-gold/50 bg-gold/[0.08] p-5" data-id="element-76" data-mp="y4xxwusoaibc">
          <h3 className="text-center text-[12px] font-bold uppercase leading-snug tracking-[0.16em] text-gold-dark" data-id="element-77" data-mp="133r37zxt330f">
            After the Menopause
            <br className="sm:hidden" data-id="element-78" data-mp="oe30qvdw1yb4" /> Clinical Blueprint™
          </h3>
          <ul className="mt-4 space-y-3" data-id="element-79" data-mp="t64nxcclh9fx">
            {afterItems.map(item => <li key={item} className="flex items-start gap-2.5 text-[14px] font-semibold leading-snug text-navy" data-id="element-80" data-mp="feg9v3iscawb">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-navy" data-id="element-81" data-mp="jg1igcoae30p">
                  <CheckIcon className="h-3 w-3 text-gold" data-id="element-82" data-mp="5icyd721mzwp" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>

      <CTAButton className="mt-8" variant="navy" label="I want the 'After' version of my practice" subline="Immediate access for $27" data-id="element-83" data-mp="2c5kbgf65tv6u" />
    </Section>;
}